<script setup lang="ts">
import { computed } from "vue";
import DRDialog from "@/components/UI/feedbacks/DRDialog.vue";
import ProgressUploader from "./ProgressUploader.vue";
import type { FileParams, FileType } from "@/types/file.types";

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    fileType: FileType;
    fileParams: FileParams;
    title: string;
    helper?: string;
    maxFiles?: number;
    maxSizeMb?: number;
    extensions?: string[];
    imagesOnly?: boolean;
    multiple?: boolean;
    uploadDescription?: (v: { maxSizeMb: number; maxFiles: number }) => string;
  }>(),
  {
    maxFiles: 100,
    maxSizeMb: 20,
    imagesOnly: false,
    extensions: () => [],
    multiple: true,
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "uploaded"): void;
}>();

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    if (!value) {
      emit("update:modelValue", false);
    }
  },
});

const cancel = () => {
  show.value = false;
};

const onUploaded = () => {
  cancel();
  emit("uploaded");
};
</script>

<template>
  <DRDialog
    v-model="show"
    :title="title"
    @cancel="cancel()"
    :close-on-click-modal="false"
    hide-footer
  >
    <div>
      <div
        v-if="helper"
        class="mb-3 rounded bg-light row align-items-start py-3 mx-2 text-dark"
      >
        <div class="col-auto d-flex">
          <el-icon size="1.5rem"><i class="bi-info-circle"></i></el-icon>
        </div>
        <div class="col">
          <small v-html="helper"> </small>
        </div>
      </div>

      <ProgressUploader
        :file-type="fileType"
        :file-params="fileParams"
        :max-files="maxFiles"
        :max-size-mb="maxSizeMb"
        :extensions="extensions"
        :images-only="imagesOnly"
        :description="uploadDescription"
        :multiple="multiple"
        @uploaded="onUploaded()"
      />
    </div>
  </DRDialog>
</template>
